import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { EventManagerPlugin } from '@angular/platform-browser';
import { fromEvent, tap, throttleTime } from 'rxjs';

const THROTTLE_PATTERN = /^([a-z]+)\.throttle\.(\d+)(ms|s)$/i;

export class ThrottleEventPlugin extends EventManagerPlugin {
  constructor() {
    super(inject(DOCUMENT));
  }

  public override supports(eventName: string): boolean {
    return THROTTLE_PATTERN.test(eventName);
  }

  public override addEventListener(
    element: HTMLElement,
    eventName: string,
    handler: (event: Event) => void,
  ): () => void {
    const match = eventName.match(THROTTLE_PATTERN)!;
    const baseEvent = match[1];
    const wait = match[3].toLowerCase() === 's' ? Number(match[2]) * 1000 : Number(match[2]);
    const zone = this.manager.getZone();

    const subscription = zone.runOutsideAngular(() =>
      fromEvent<Event>(element, baseEvent)
        .pipe(
          tap((event) => {
            event.preventDefault();
            event.stopPropagation();
          }),
          throttleTime(wait),
        )
        .subscribe((event) => zone.runGuarded(() => handler(event))),
    );

    return () => subscription.unsubscribe();
  }
}
